import { render, staticRenderFns } from "./ChallengeHeader.vue?vue&type=template&id=19c211ae"
import script from "./ChallengeHeader.vue?vue&type=script&lang=js"
export * from "./ChallengeHeader.vue?vue&type=script&lang=js"
import style0 from "./ChallengeHeader.vue?vue&type=style&index=0&id=19c211ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports